(function () {
    'use strict';

    angular
        .module('nasracApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        var roles = ['Administrators'];
        $stateProvider
            .state('change-management-hours-report', {
                parent: 'reports',
                url: '/changemanagementhoursreport',
                data: {
                    authorities: ['Administrators', 'DAC Content Administrator', 'DAC Content User', 'Customer Users'],
                    pageTitle: 'nasracApp.changemanagementHoursReport.home.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/reports/change-management-hours-report/change-management-hours-report.html',
                        controller: 'ChangeManagementHoursMainController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('changeManagementHoursReport');
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            });
    }
})();
